import { getName } from "js/formatting";
import { useTranslation } from "react-i18next";

import CardWithFields from "components/General/CardWithFields";
import CardDisclaimerBase from "components/General/CardDisclaimerBase";

export default function InsuredCard({ insureds, policy }) {
  const { t } = useTranslation();
  const getTitle = (key) => t(`${key}`);

  const sortedInsureds = [
    ...insureds.filter((i) => i?.person?.partyTypeCode === "IN"),
    ...insureds.filter((i) => i?.person?.partyTypeCode === "I2"),
  ];

  const cardFields = [
    {
      title: getTitle("CustomerPolicyDetails-insured-name"),
      value: sortedInsureds.map((insured, idx) => (
        <p key={`insured-name-${idx}`}>
          {getName(insured.person)}
          <br />
        </p>
      )),
    },
    {
      title: getTitle("CustomerPolicyDetails-insured-dob"),
      value: sortedInsureds.map((insured, idx) => (
        <p key={`insured-dob-${idx}`}>
          {insured.person.dateofBirth}
          <br />
        </p>
      )),
    },
    {
      title: getTitle("CustomerPolicyDetails-insured-issue-date"),
      value: sortedInsureds.map((insured, idx) => (
        <p key={`insured-issue-age-${idx}`}>
          {insured.person.partyTypeCode === "IN" ? policy?.insuredIssueAge : ""}
          <br />
        </p>
      )),
    },
  ];

  return (
    <CardWithFields
      ariaLabel={t("CustomerPolicyDetails-insured-aria-label")}
      cardTitle={t("CustomerPolicyDetails-insured-card-title")}
      cardFields={cardFields}
      additionalContent={
        <CardDisclaimerBase
          disclaimer={t("CustomerPolicyDetails-insured-disclaimer")}
        />
      }
    />
  );
}
